import Vue from 'vue'
import App from './App.vue'
import Preload from './app/components/preload.vue'
import router from './app/router'
import store from './common/js/store'
import VueLoading from 'vue-loading-overlay'
import fontawesome from '@fortawesome/fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'

import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

import VueMoment from 'vue-moment'
//import moment from 'moment-timezone'
import 'moment/locale/ru'

Vue.use(VueMoment);

fontawesome.library.add(solid)

//import 'bulma/css/bulma.css'

Vue.use(VueLoading);
Vue.use(Preload);

new Vue({
    el: '#app',
    data: {
        isLoading: false
    },
    store,
    router,
    // template: '<App/>',
    // components: {App},
    render: h => h(App),
    components: {
    'preloader': Preload
    //dragscroll
}
});


// WEBPACK FOOTER //
// ./vue-source/src/main.js